import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TenantModalService } from './tenant-modal.service';

@Component({
  selector: 'app-tenant-modal',
  templateUrl: './tenant-modal.component.html',
  styleUrl: './tenant-modal.component.css'
})
export class TenantModalComponent implements OnInit, OnDestroy {

  isVisible = false;
  title = 'Data Tenant';
  tenants: string[] = [];

  private modalSubscription: Subscription | undefined;

  constructor(
    private modalService: TenantModalService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.modalSubscription = this.modalService.modalState$.subscribe(state => {
      if (state) {
        this.isVisible = state.isOpen;
        this.tenants = state.data || [];

        // Enable Bootstrap modal scrollable behavior
        if (this.isVisible) {
          document.body.classList.add('modal-open');
        }
      } else {
        this.isVisible = false;
        document.body.classList.remove('modal-open');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
    document.body.classList.remove('modal-open');
  }

  close(): void {
    this.modalService.closeModal();
  }


}
